var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#1ca0db;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3638",
    "data-name": "Group 3638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3636",
    "data-name": "Group 3636"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16038",
    "data-name": "Path 16038",
    className: "cls-1",
    d: "M2.771,87.048H112.227a.766.766,0,0,1,.767.767h0v2.338a4,4,0,0,1-4,4H6.006a4,4,0,0,1-4-4V87.815A.767.767,0,0,1,2.771,87.048Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    className: "cls-1",
    x1: 55.817,
    y1: 26.351,
    x2: 59.18,
    y2: 26.351
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    className: "cls-1",
    x1: 12.655,
    y1: 31.62,
    x2: 102.344,
    y2: 31.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16039",
    "data-name": "Path 16039",
    className: "cls-1",
    d: "M2.565,87.09,12.654,75.84V28.975a8.129,8.129,0,0,1,8.129-8.128H94.215a8.128,8.128,0,0,1,8.128,8.128V75.837L112.437,87.09"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    className: "cls-1",
    x1: 12.655,
    y1: 75.876,
    x2: 102.344,
    y2: 75.876
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    className: "cls-1",
    x1: 55.817,
    y1: 81.818,
    x2: 58.059,
    y2: 81.818
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    className: "cls-1",
    x1: 63.665,
    y1: 81.818,
    x2: 65.907,
    y2: 81.818
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    className: "cls-1",
    x1: 40.122,
    y1: 81.818,
    x2: 42.364,
    y2: 81.818
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    className: "cls-1",
    x1: 47.97,
    y1: 81.818,
    x2: 50.212,
    y2: 81.818
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    className: "cls-1",
    x1: 32.274,
    y1: 81.818,
    x2: 34.516,
    y2: 81.818
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    className: "cls-1",
    x1: 16.579,
    y1: 81.818,
    x2: 18.821,
    y2: 81.818
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    className: "cls-1",
    x1: 24.426,
    y1: 81.818,
    x2: 26.668,
    y2: 81.818
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_68",
    "data-name": "Line 68",
    className: "cls-1",
    x1: 88.33,
    y1: 81.818,
    x2: 90.572,
    y2: 81.818
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    className: "cls-1",
    x1: 96.177,
    y1: 81.818,
    x2: 98.419,
    y2: 81.818
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_70",
    "data-name": "Line 70",
    className: "cls-1",
    x1: 80.482,
    y1: 81.818,
    x2: 82.724,
    y2: 81.818
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3637",
    "data-name": "Group 3637"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16040",
    "data-name": "Path 16040",
    className: "cls-1",
    d: "M77.118,52.122V67.266A2.323,2.323,0,0,1,74.8,69.589H40.2a2.323,2.323,0,0,1-2.323-2.323V52.122m17.553,5.791H41.15a3.27,3.27,0,0,1-3.269-3.27V49.911a5.764,5.764,0,0,1,5.762-5.766h27.71a5.764,5.764,0,0,1,5.765,5.763v4.735a3.27,3.27,0,0,1-3.27,3.27H59.565m-.843,3.442H56.276a.842.842,0,0,1-.842-.842V56a.842.842,0,0,1,.841-.843h2.447a.842.842,0,0,1,.843.843h0v4.511a.842.842,0,0,1-.842.842Zm2.835-22.716H54.132a2.483,2.483,0,0,0-2.484,2.482h0v3.025H64.039V41.122a2.483,2.483,0,0,0-2.483-2.483Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareers);
export default __webpack_public_path__ + "static/media/careers.b8613bd1317f2670d203e2acbc79b9eb.svg";
export { ForwardRef as ReactComponent };